import ErrorPage from "@shared/components/ErrorPage";
import { IdToken, parseIdToken } from "@shared/http/id-token";
import { NullRollbarService, ProductionRollbarService } from "@shared/services/RollbarService";
import { ErrorBoundary } from "react-error-boundary";
import SherlockDashboard from "./components/SherlockDashboard";
import "./index.css";

const loginBaseURL = import.meta.env.VITE_LOGIN_URL as string;
const rollbarService =
  process.env.NODE_ENV === "production" ? new ProductionRollbarService() : new NullRollbarService();

export default function App() {
  const idToken = parseIdToken();

  if (!idToken || !idToken.user.id) {
    redirectToLogin();
    return null;
  }

  if (!userHasAccess(idToken)) {
    return null;
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorPage} onError={onError}>
      <SherlockDashboard />
    </ErrorBoundary>
  );
}
function userHasAccess(idToken: IdToken) {
  return idToken.user.admin;
}

function onError(error: Error) {
  rollbarService.error(error);
  return;
}

function redirectToLogin() {
  window.location.href = loginBaseURL;
}
